import { render, staticRenderFns } from "./PiePlace.vue?vue&type=template&id=a9ede4ea&"
import script from "./PiePlace.vue?vue&type=script&lang=js&"
export * from "./PiePlace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports